






























































































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import ProductCartButton from '~/components/pages/Product/ProductCartButton.vue';
import ProductWineColorLabel from '~/components/pages/Product/ProductWineColorLabel.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppOptimizedImage from '~/components/partials/App/AppOptimizedImage.vue';
import ProducingAreaFlag from '~/components/partials/ProducingArea/ProducingAreaFlag.vue';
import { useSilverEggApi } from '~/composables/silverEgg/useSilverEggApi';
import { BOTTLE_200 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import { convertColorText, filterReviewRating } from '~/utils/modules/products';
import { CommonProducingArea } from '~/types/common';
import { ConvertedRecommendItem } from '~/types/common/silverEgg';
import { TopItemDetail } from '~/types/modules/top';
import { PromotionsName } from '~/enums';

export default defineComponent({
  components: {
    AppOptimizedImage,
    AppLink,
    AppIcon,
    ProductWineColorLabel,
    ProducingAreaFlag,
    ProductCartButton,
  },
  props: {
    item: {
      type: Object as PropType<TopItemDetail | ConvertedRecommendItem>,
      required: true,
    },
    // ↓シルバーエッグ用↓
    rqid: {
      type: String,
      default: '',
    },
    spec: {
      type: String,
      default: '',
    },
    // ↑シルバーエッグ用↑
    isClamped: {
      type: Boolean,
      default: false,
    },
    // 割引率ラベルの位置を制御用
    isRecommend: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { clickNotify } = useSilverEggApi();

    const colorText = computed(() => convertColorText(props.item.product.color));

    const producingArea = computed((): CommonProducingArea => {
      const { producing_area } = props.item.product;

      // リンクなしの仕様なので、areas.idは不要です
      return {
        code_id: producing_area.area_id_1 || '',
        areas: [
          {
            name: producing_area.area_1,
          },
          {
            name: producing_area.area_2,
          },
          {
            name: producing_area.area_3,
          },
        ],
      };
    });

    // シルバーエッグにクリック通知を送信する
    const sendSilverEggRequest = async () => {
      if (!props.spec || !props.rqid) return;
      await clickNotify({
        itemId: props.item.code,
        spec: props.spec,
        rqid: props.rqid,
      });
    };

    /**
     * dev, stg環境でのみ画像パスの末尾に /original がつくデータが存在するため、プロファイルを差し替える
     */
    const imageUrl = computed(() => {
      if (!props.item.image) return;

      return props.item.image.split('/').slice(-1)[0] === 'original'
        ? props.item.image.replace('/original', BOTTLE_200)
        : props.item.image + BOTTLE_200;
    });

    return {
      url,
      colorText,
      producingArea,
      imageUrl,
      filterReviewRating,
      PromotionsName,
      sendSilverEggRequest,
    };
  },
});
